export default function Reputation() {
  const reviews = [
    {
      name: '张先生',
      role: '资深影迷',
      rating: 5,
      content: '蘑菇视频官网是我最常用的视频平台，片源丰富更新快，4K画质真的非常震撼。会员价格也很合理，已经续费第三年了。',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Chinese%20man%20in%20casual%20shirt%2C%20warm%20lighting%2C%20friendly%20expression%2C%20clean%20background%2C%20natural%20pose&width=100&height=100&seq=avatar-user-1&orientation=squarish',
    },
    {
      name: '李女士',
      role: '全职妈妈',
      rating: 5,
      content: '少儿模式功能太棒了！现在可以放心让孩子在蘑菇视频上看动画片，时长控制和内容筛选都很到位，强烈推荐给有娃家庭。',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Chinese%20woman%20with%20warm%20smile%2C%20soft%20natural%20lighting%2C%20clean%20background%2C%20friendly%20approachable%20look&width=100&height=100&seq=avatar-user-2&orientation=squarish',
    },
    {
      name: '王同学',
      role: '大学生',
      rating: 5,
      content: '蘑菇视频的纪录片资源太丰富了！BBC、Discovery的经典系列基本都有，写论文查资料的时候帮了大忙。离线下载功能也很实用。',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Chinese%20student%2C%20casual%20style%2C%20bright%20natural%20lighting%2C%20clean%20background%2C%20youthful%20energetic%20expression&width=100&height=100&seq=avatar-user-3&orientation=squarish',
    },
    {
      name: '刘总',
      role: '企业高管',
      rating: 5,
      content: '出差路上就看蘑菇视频，多端同步真的方便。手机上看一半，回到酒店电视上继续看，无缝衔接。内容品质一直很稳定。',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Chinese%20businessman%20in%20suit%2C%20confident%20expression%2C%20studio%20lighting%2C%20clean%20background%2C%20corporate%20professional%20look&width=100&height=100&seq=avatar-user-4&orientation=squarish',
    },
  ];

  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-100/70">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
            用户口碑
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-3" style={{ fontFamily: "var(--font-heading)" }}>
            听听用户怎么说
          </h2>
          <p className="text-sm text-foreground-500">
            蘑菇视频官网收获了来自各行业用户的好评与信赖
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {reviews.map((review) => (
            <div
              key={review.name}
              className="p-5 md:p-6 rounded-xl bg-background-50"
            >
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={review.avatar}
                    alt={review.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex-1">
                  <div className="flex items-center justify-between mb-1">
                    <div>
                      <h4 className="text-sm font-semibold text-foreground-900">{review.name}</h4>
                      <p className="text-xs text-foreground-500">{review.role}</p>
                    </div>
                    <div className="flex items-center gap-0.5">
                      {Array.from({ length: review.rating }).map((_, i) => (
                        <i key={i} className="ri-star-fill text-accent-500 text-xs"></i>
                      ))}
                    </div>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed mt-2">
                    &ldquo;{review.content}&rdquo;
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}